import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

// función util para armar redirect conservando la URL a la que querían entrar
function redirectToSignIn(router: Router, segments: UrlSegment[]): UrlTree {
  const redirect = '/' + segments.map(s => s.path).join('/');
  return router.createUrlTree(['/sign-in'], { queryParams: { redirect } });
}

// Privadas: solo si logueado
export const authMatch: CanMatchFn = async (_route, segments: UrlSegment[]): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const auth = inject(AuthService);

  // Asegura bootstrap de sesión (web o nativo). Idempotente.
  await auth.ensureSession();

  // Si no hay sesión → login
  if (!auth.isLoggedIn()) return redirectToSignIn(router, segments);

  return true;
};

// guard que además exige email verificado
export const verifiedMatch: CanMatchFn = async (_route, segments) => {
  const router = inject(Router);
  const auth   = inject(AuthService);

  await auth.ensureSession();

  // si NO está logueado -> sign-in
  if (!auth.isLoggedIn()) return redirectToSignIn(router, segments);

  // si está logueado pero NO verificado -> verify-email
  if (!auth.isVerified()) {
    const redirect = '/' + segments.map((s: UrlSegment) => s.path).join('/');
    return router.createUrlTree(['/verify-email'], { queryParams: { redirect } });
  }

  return true;
};

// Guest-only: solo si NO logueado
export const guestOnlyMatch: CanMatchFn = async (): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const auth = inject(AuthService);

  // también esperamos sesión aquí para evitar parpadeos/loops
  await auth.ensureSession();

  // Si NO está logueado → puede pasar
  if (!auth.isLoggedIn()) return true;

  // logueado pero NO verificado -> verify-email
  if (!auth.isVerified()) return router.createUrlTree(['/verify-email']);

  // Si ya está logueado, mandalo a tu home/logged route
  return router.createUrlTree(['/dashboard']);
};